export const featuresConfig = {
  isCollectibleCounterActive: true,
  isAnalyticsDataEnabled: false,
  isProfilePageEnabled: false,
  isLegacyLinksEnabled: false,
};
